'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { CurrencySelectorContent, useCurrencySelection } from '@/components/currency-selector';
import { AnimatedButton } from '@/components/ui/animated-button';
import { useFundingStage } from '../shared/funding-chrome';
export function FundingCurrency(t0) {
  const $ = _c(16);
  const {
    onBack
  } = t0;
  const t = useTranslations("onramp");
  const currency = useTranslations("currency");
  const state = useCurrencySelection();
  let t1;
  if ($[0] !== t) {
    t1 = t("profile_currency_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useFundingStage(t1, false, onBack);
  let t2;
  if ($[2] !== state) {
    t2 = <CurrencySelectorContent state={state} />;
    $[2] = state;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !state.hasChange;
  let t4;
  if ($[4] !== onBack || $[5] !== state) {
    t4 = () => state.apply(onBack);
    $[4] = onBack;
    $[5] = state;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== currency) {
    t5 = currency("update_button");
    $[7] = currency;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <AnimatedButton disabled={t3} onClick={t4}>{t5}</AnimatedButton>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t2}{t6}</div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}